const safeEncodeUrl = (url: string) => {
  const safeUrl = url?.replace(/#/g, "%23");
  return safeUrl;
};

const urlHelper = {
  safeEncodeUrl,
};

export default urlHelper;
